import React from 'react';
import { useSeoHead } from '../../hooks/useSeoHead';

/**
 * Renderable wrapper around useSeoHead so it can be dropped into the public
 * layout (which is plain JSX) to keep canonical URLs in sync on every route.
 */
export function CanonicalManager() {
  useSeoHead({});
  return null;
}

export default CanonicalManager;
